import React, { lazy } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
export function Login() {
  const navigate = useNavigate();
  const handleGoogleLogin = () => {
    // TODO: Implement actual Google Sign-In logic here
    console.log('Google Sign-In initiated');
    // Get selected report type from localStorage
    const selectedReport = localStorage.getItem('selectedReport') || 'quick-self-decode';
    // TODO: In production, check if adult baseline exists in database
    const hasAdultBaseline = false; // This would come from API/database
    // CLASS A: Internal Architecture Reports (Quick Self Decode - FREE)
    const classAFreeReports = ['self-orientation', 'work-orientation', 'quick-self-decode'];
    // CLASS A: Internal Architecture Reports (Paid - require baseline check)
    const classAPaidReports = ['deep-self-decode', 'work-self-decode', 'inner-child-decode', 'good-boy-decode'];
    // CLASS B: Relational System Reports (No adult baseline, collect in-flow)
    const classBReports = ['work-relationship-decode', 'relationship-decode'];
    // CLASS C: Kids Decode (Child baseline only)
    const classCReports = ['kids-decode'];
    // Route based on report class
    if (classAFreeReports.includes(selectedReport)) {
      // CLASS A FREE: Quick Self Decode and Quick Work Decode (collects baseline in-flow, stays in free flow)
      if (selectedReport === 'work-orientation') {
        navigate('/quick-work-decode');
      } else {
        navigate('/quick-self-decode');
      }
    } else if (classAPaidReports.includes(selectedReport)) {
      // CLASS A PAID: Deep Self Decode and Deep Work Decode (paid diagnostic flows)
      if (selectedReport === 'work-self-decode') {
        navigate('/deep-work-decode');
      } else {
        navigate('/deep-self-decode');
      }
    } else if (classBReports.includes(selectedReport)) {
      // CLASS B: Relational System Reports (paid diagnostics - one-sided for work, two-sided for personal)
      if (selectedReport === 'work-relationship-decode') {
        navigate('/work-relationship-decode');
      } else {
        navigate('/relationship-decode');
      }
    } else if (classCReports.includes(selectedReport)) {
      // CLASS C: Kids Decode (Child baseline only - paid diagnostic)
      navigate('/kids-decode');
    } else {
      // Default fallback: Quick Self Decode
      navigate('/quick-self-decode');
    }
  };
  return <>
      <Helmet data-id="element-1982">
        <title data-id="element-1983">Login — Decode | Lazy Monk Labs</title>
        <meta name="description" content="Clarity requires continuity. Your diagnostic reports build on each other." data-id="element-1984" />
        <meta name="robots" content="noindex, nofollow" data-id="element-1985" />
        <link rel="canonical" href="https://lazymonklabs.com/login" data-id="element-1986" />
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-QCXDHW3F0P" data-id="element-1987"></script>
        <script data-id="element-1988">{`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-QCXDHW3F0P');`}</script>
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5] flex flex-col" data-id="element-1989">
        <header data-id="element-1990">
          <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-sm border-b border-[#2B2B2B]" role="navigation" aria-label="Main navigation" data-id="element-1991">
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-1992">
              <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity" aria-label="Return to Lazy Monk Labs home" data-id="element-1993">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jXd6KyuddrgAfqwwkkpUrR/Lazy_Monk_Labs_Logo.png" alt="Lazy Monk Labs Logo" className="h-8 w-auto" width="32" height="32" data-id="element-1994" />
                <span className="text-lg font-medium tracking-tight" data-id="element-1995">
                  Lazy Monk Labs
                </span>
              </Link>
              <div className="flex items-center gap-8" data-id="element-1996">
                <Link to="/decode" className="text-sm text-[#F5F5F5]/80 hover:text-[#F5F5F5] transition-colors" data-id="element-1997">
                  Decode
                </Link>
                <a href="https://wa.me/919633096997" target="_blank" rel="noopener noreferrer" className="text-sm text-[#F5F5F5]/80 hover:text-[#F5F5F5] transition-colors" aria-label="Contact us on WhatsApp" data-id="element-1998">
                  Contact
                </a>
              </div>
            </div>
          </nav>
        </header>

        <main className="flex-1 flex items-center justify-center px-6 pt-20 pb-16" data-id="element-1999">
          <div className="max-w-md mx-auto text-center w-full" data-id="element-2000">
            <h1 className="text-4xl md:text-5xl font-medium mb-6 leading-tight tracking-tight" data-id="element-2001">
              Clarity requires continuity.
            </h1>
            <p className="text-lg text-[#F5F5F5]/70 mb-12 leading-relaxed" data-id="element-2002">
              Your diagnostic reports build on each other.
            </p>
            <button onClick={handleGoogleLogin} className="w-full px-8 py-5 bg-[#F5F5F5] text-[#0A0A0A] font-semibold text-sm tracking-widest uppercase hover:bg-[#F5F5F5]/90 transition-colors shadow-lg flex items-center justify-center gap-3" aria-label="Continue with Google Sign-In" data-id="element-2003">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-2004">
                <path d="M19.6 10.227c0-.709-.064-1.39-.182-2.045H10v3.868h5.382a4.6 4.6 0 01-1.996 3.018v2.51h3.232c1.891-1.742 2.982-4.305 2.982-7.35z" fill="#4285F4" data-id="element-2005" />
                <path d="M10 20c2.7 0 4.964-.895 6.618-2.423l-3.232-2.509c-.895.6-2.04.955-3.386.955-2.605 0-4.81-1.76-5.595-4.123H1.064v2.59A9.996 9.996 0 0010 20z" fill="#34A853" data-id="element-2006" />
                <path d="M4.405 11.9c-.2-.6-.314-1.24-.314-1.9 0-.66.114-1.3.314-1.9V5.51H1.064A9.996 9.996 0 000 10c0 1.614.386 3.14 1.064 4.49l3.34-2.59z" fill="#FBBC05" data-id="element-2007" />
                <path d="M10 3.977c1.468 0 2.786.505 3.823 1.496l2.868-2.868C14.959.99 12.695 0 10 0 6.09 0 2.71 2.24 1.064 5.51l3.34 2.59C5.19 5.736 7.395 3.977 10 3.977z" fill="#EA4335" data-id="element-2008" />
              </svg>
              Continue with Google
            </button>
            <p className="text-xs text-[#F5F5F5]/40 mt-8" data-id="element-2009">
              We don't sell or share your data.
            </p>
          </div>
        </main>

        <footer className="py-8 px-6 border-t border-[#2B2B2B]" role="contentinfo" data-id="element-2010">
          <div className="max-w-7xl mx-auto text-center" data-id="element-2011">
            <p className="text-xs text-[#F5F5F5]/40" data-id="element-2012">
              © {new Date().getFullYear()} Lazy Monk Labs. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </>;
}